import { Link } from 'react-router-dom';
import { allVideos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const featured = allVideos.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            精选推荐
          </h2>
          <Link to="/category/all" className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap flex items-center gap-1">
            更多好剧 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {featured.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.categorySlug}`}
              className="group block cursor-pointer"
            >
              {/* Cover Image */}
              <div className="relative aspect-video rounded-lg overflow-hidden bg-background-200 mb-3">
                <img
                  src={video.coverImage}
                  alt={video.title}
                  title={`${video.title} - 桔子视频高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform scale-75 group-hover:scale-100">
                    <i className="ri-play-fill text-2xl text-background-50"></i>
                  </div>
                </div>
                {/* Rating Badge */}
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded text-xs font-semibold bg-background-50/90 text-primary-500">
                  {video.rating}
                </div>
                {/* Category Tag */}
                <div className="absolute bottom-2 left-2 px-2 py-0.5 rounded text-xs bg-primary-500/90 text-background-50">
                  {video.category}
                </div>
              </div>
              {/* Info */}
              <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-400 transition-colors line-clamp-1 mb-1">
                {video.title}
              </h3>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span>{video.year}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-500"></span>
                <span>{video.views}次播放</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}